// src/reportTemplates.js
export const REPORT_TEMPLATES = {
  default: {
    label: "Default report",
    // whatever you already use today; can be empty if default report uses old pipeline
    sections: []
  },

  // keyed by client slug
  "stack-data-strategy": {
    label: "Client report",
    sections: [
      {
        id: "bespoke-questions",
        title: "Client questions",
        // each "groupId" corresponds to your groupsById keys like windfall_banks
        items: [
          { groupId: "windfall_banks", chart: "likert_4" },
          // { groupId: "another_question", chart: "top2" },
        ],
      },
    ],
  },

  
};
